<script>
  import { min } from 'lodash';
  import { Line, mixins } from 'vue-chartjs';

  const { reactiveProp } = mixins;

  export default {
    extends: Line,
    name: 'proficiency-line-chart',
    mixins: [reactiveProp],
    props: [
      'chartData',
      'dataset',
      'labels',
    ],
    data() {
      return {
        options: {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            pointLabels: {
              display: true,
              fontColor: '#ffffff',
              fontSize: 12,
            },
            yAxes: [{
              gridLines: {
                zeroLineWidth: 1,
                scaleShowGridLines: true,
                display: false,
                drawBorder: true,
                color: 'rgba(255, 255, 255, 0)',
              },
              scaleLabel: {
                display: false,
              },
              scaleShowLabels: false,
              ticks: {
                display: true,
                beginAtZero: true,
                stepSize: 250,
                fontColor: '#ffffff',
                fontSize: 12,
              },
            }],
            xAxes: [{
              position: 'bottom',
              gridLines: {
                display: false,
                scaleShowGridLines: true,
                drawBorder: true,
                color: 'rgba(255, 255, 255, 0.1)',
              },
              ticks: {
                display: true,
                beginAtZero: false,
                fontColor: '#ffffff',
                fontSize: 12,
              },
            }],
          },
          legend: {
            display: false,
          },
        },
      };
    },

    mounted() {
      const maxX = min([window.innerWidth, 700]);
      const gradient = this.$refs.canvas.getContext('2d').createLinearGradient(10, 0, maxX, 0);
      gradient.addColorStop(0, 'rgba(255, 255, 255, 0.05)');
      gradient.addColorStop(1, 'rgba(255, 255, 255, 0.4)');

      const chartData = {
        labels: this.labels,
        datasets: [
          {
            ...this.dataset,
            backgroundColor: gradient,
          },
        ],
      };

      this.renderChart(chartData, { ...this.options });
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/ProficiencyLineChart.vue